import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import LocaleSwitcher from "../common/components/LocaleSwitcher";

const Landing = () => {
  const [state, setState] = React.useState({
    checkedA: true,
  });
  const [occasions, setOccasions] = useState([]);

  const [selected, setSelected] = useState({});
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();


  const [formData, setFormData] = useState({
    occasion: "",
    cardTitle: "",
    cardImage: ""
  });


  const [error, setError] = useState({
    occasion: ""
  });


  useEffect(() => {
    fetchOccasions();
  }, []);

  const fetchOccasions = async () => {
    setLoader(true)
    try {
      const response = await fetch(process.env.REACT_APP_OCCASOIN_API);
      if (response.ok) {
        const data = await response.json();
        if (data.status === "SUCCESS") {
          setOccasions(data.data);
          setLoader(false)
        } else {
          console.error("API response status is not success:", data.error);
        }
      } else {
        console.error("Failed to fetch occasions:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching occasions:", error);
    }
  };


  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoader(false);
  //   }, 300);
  // }, []);

  const handleSelect = (card) => {
    setSelected(card); // For applying selected class
    setFormData({
      ...formData,
      cardTitle: card.name,
      cardImage: `data:image/png;base64,${card.image}`,
      occasion: occasions[0].title_en,
      textColor: card?.text_color,
      textSize: card?.text_size,
      textAlign: card?.text_position
    });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    let newError = { ...error };

    if (!formData.occasion || !formData.cardTitle) {
      newError.occasion = "Select a Card";
    } else {
      newError.occasion = "";
      navigate("/registration", { state: formData });
    }

    setError(newError);
  };

  return (
    <>

      <div className="w-full min-h-screen pt-[22px] md:pb-20 pb-4 relative flex justify-center items-center flex-col px-4">
        <img
          className="hidden md:block absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
          src="/background.png"
          alt=""
        />
        <img
          className="md:hidden absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
          src="/background-sm.png"
          alt=""
        />

        <img
          className="brand_logo w-[70px] md:w-[100px] xl:w-[143px] mb-6"
          src="/logo_robi_horizontal.svg"
          alt=""
        />

        {loader ?
          <div className="relative w-full h-[100px]">
            <svg className="spinner" viewBox="0 0 50 50">
              <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
            </svg>
          </div>
          :
          <div className="relative flex flex-col justify-center w-full sm:max-w-[1154px] bg-white border border-gray-100 rounded-lg mx-auto z-50 box-shadow lg:pt-10 pt-7 lg:pb-9 lg:px-[50px] p-4 md:h-auto h-[calc(100vh-200px)] ">
            <h2 className="text-[#BC2626] font-semibold lg:text-[30px] text-[22px] text-center md:mb-8 mb-4">{occasions.length > 0 && occasions[0].title_en}</h2>
            <div className="flex flex-wrap gap-x-[18px] md:gap-y-[36px] gap-y-[12px] justify-center md:mb-10 mb-5 overflow-auto select-card-wrapper">
              {occasions.length > 0 &&
                occasions[0]?.cards?.map((card, index) => (
                  <button
                    key={index}
                    className={`md:w-[calc(100%/3-12px)] w-full ${selected?.name === card.name ? "border border-[#5B2D90] rounded-[10px] p-2" : ""}`} onClick={() => handleSelect(card)}>
                    <img src={`data:image/png;base64,${card.image}`} alt="eid-card" className="w-full aspect-auto md:mb-[18px] mb-2" />
                    <p className="lg:text-lg text-base font-medium text-[#5E6A7A] text-center">{card.name}</p>
                  </button>
                ))}
            </div>
            {error.occasion && <p className="text-center text-[#BC2626] mb-1">{error.occasion}</p>}
            <button
              type="submit"
              className="w-full text-white max-w-[454px] mx-auto bg-[#5B2D90] hover:bg-purple-900 focus:ring-4  font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              onClick={onSubmitHandler}
            >
              Generate Card
            </button>
          </div>
        }


      </div>
    </>
  );
};

export default Landing;
